// External components
import Vue from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import Login from '@/pages/Login.vue'
import Manual from '@/pages/Manual.vue'
import NotFound from '@/pages/NotFound.vue'
import NotAllowed from '@/pages/NotAllowed.vue'
import EnergyReport from '@/pages/EnergyReport.vue'

import store from '@/store/store'

const routes = [
  {
    name: 'Login',
    path: '/login/:idSystem/:endDate',
    component: Login
  }, {
    name: 'Manual',
    path: '/manual',
    component: Manual
  }, {
    name: 'EnergyReport',
    path: '/energyreport/:idSystem/:endDate',
    component: EnergyReport
  }, {
    name: 'NotAllowed',
    path: '/notallowed',
    component: NotAllowed
  }, {
    name: 'NotFound',
    path: '/:catchAll(.*)',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
